import { Fragment } from 'react';
import PropTypes from 'prop-types';

import CustomLink from 'src/components/CustomLink';
import ErrorPanel from 'src/components/ErrorPanel';
import { ROUTES } from 'src/routes';

export const RegistrationError = ({ className, error }) => {
  const EMAIL_ALREADY_IN_USE_ERROR = 'Email already in use.';
  const isEmailAlreadyInUseError = error === EMAIL_ALREADY_IN_USE_ERROR;

  return (
    <ErrorPanel
      classes={{ root: className }}
      type="warning"
      text={
        isEmailAlreadyInUseError ? (
          <Fragment>
            {error}{' '}
            <CustomLink to={ROUTES.RESET_PASSWORD}>Reset password</CustomLink>
          </Fragment>
        ) : (
          error
        )
      }
    />
  );
};

RegistrationError.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
};

RegistrationError.defaultProps = {
  className: null,
  error: null,
};
